export default __webpack_public_path__ + "static/media/nobbAcccountPng.6f346949.png";